/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { EventsCouncilFeedComponentEditor } from "cms/components/components/events-council-feed/edit";
import { EventsCouncilFeedComponentDisplay } from "cms/components/components/events-council-feed/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const EventsCouncilFeedComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <EventsCouncilFeedComponentDisplay />,
        editComponent: <EventsCouncilFeedComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

EventsCouncilFeedComponent.displayName = "EventsCouncilFeedComponent";
export { EventsCouncilFeedComponent };

